import { styled } from "sharedUI/styles";

export const UserHeaderStyle = styled.div`
    .uhs-col {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 8px;
        grid-row-gap: 8px;
    }

    .uhs-left {
        color: ${p => p.theme.textPale};
    }

    .uhs-right {
        &,
        & > * {
            text-align: right;
        }
    }

    a,
    button {
        color: ${p => p.theme.b500};
        transition: color ${p => p.theme.transitionBase};
        cursor: pointer;

        &:hover,
        &:focus {
            color: ${p => p.theme.b400};
            text-decoration: underline;
        }
    }
`;
